// Shared so every search-as-you-type field feels the same.
const SEARCH_DEBOUNCE_MS = 500
export default SEARCH_DEBOUNCE_MS
